import { render, staticRenderFns } from "./DashboardLink.vue?vue&type=template&id=e862750a&scoped=true&"
import script from "./DashboardLink.vue?vue&type=script&lang=js&"
export * from "./DashboardLink.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLink.vue?vue&type=style&index=0&id=e862750a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e862750a",
  null
  
)

export default component.exports